/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrizeClaimResponse
 */
export interface PrizeClaimResponse {
    /**
     * The unique identifier of the prize won
     * @type {string}
     * @memberof PrizeClaimResponse
     */
    prizeId: string;
    /**
     * The name of the prize won
     * @type {string}
     * @memberof PrizeClaimResponse
     */
    prizeName: string;
    /**
     * The wallet address that claimed the prize
     * @type {string}
     * @memberof PrizeClaimResponse
     */
    wallet: string;
    /**
     * The type of prize (e.g., "coin_airdrop", "download")
     * @type {string}
     * @memberof PrizeClaimResponse
     */
    prizeType?: string;
    /**
     * Prize-specific action data (e.g., redeem code/URL for coin airdrops, download URL for downloads)
     * @type {{ [key: string]: any; }}
     * @memberof PrizeClaimResponse
     */
    actionData?: { [key: string]: any; };
}

/**
 * Check if a given object implements the PrizeClaimResponse interface.
 */
export function instanceOfPrizeClaimResponse(value: object): value is PrizeClaimResponse {
    let isInstance = true;
    isInstance = isInstance && "prizeId" in value && value["prizeId"] !== undefined;
    isInstance = isInstance && "prizeName" in value && value["prizeName"] !== undefined;
    isInstance = isInstance && "wallet" in value && value["wallet"] !== undefined;

    return isInstance;
}

export function PrizeClaimResponseFromJSON(json: any): PrizeClaimResponse {
    return PrizeClaimResponseFromJSONTyped(json, false);
}

export function PrizeClaimResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrizeClaimResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prizeId': json['prize_id'],
        'prizeName': json['prize_name'],
        'wallet': json['wallet'],
        'prizeType': !exists(json, 'prize_type') ? undefined : json['prize_type'],
        'actionData': !exists(json, 'action_data') ? undefined : json['action_data'],
    };
}

export function PrizeClaimResponseToJSON(value?: PrizeClaimResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'prize_id': value.prizeId,
        'prize_name': value.prizeName,
        'wallet': value.wallet,
        'prize_type': value.prizeType,
        'action_data': value.actionData,
    };
}

